import type { AggregateResult, AggregateRow, ParameterKey } from '../weldParameterAggregator'
import { ALL_PARAMETERS } from '../weldParameterAggregator'
import type { AlxPassRow } from './types'

const NULL_TRIPLE = { min: null, avg: null, max: null }

function rowToAggregate(
  row: AlxPassRow,
  mappedPass: string
): AggregateRow {
  const m = row.metrics
  const values = {} as Record<ParameterKey, { min: number | null; avg: number | null; max: number | null }>

  for (const key of ALL_PARAMETERS) {
    values[key] = { ...NULL_TRIPLE }
  }

  values.volts = {
    min: m.voltageMin,
    avg: m.voltageAvg,
    max: m.voltageMax
  }
  values.amps = {
    min: m.currentMin,
    avg: m.currentAvg,
    max: m.currentMax
  }
  values.travelSpeed = {
    min: null,
    avg: m.travelSpeedInchPerMin,
    max: null
  }
  values.heatInput = {
    min: null,
    avg: m.heatInputKJPerInch,
    max: null
  }

  return {
    pass: row.passName,
    wpsPass: mappedPass,
    torches: [],
    sampleCount: 1,
    values
  }
}

export function identityAlxPassMappings(passNames: string[]): Record<string, string> {
  const mappings: Record<string, string> = {}
  for (const name of passNames) {
    if (name) mappings[name] = name
  }
  return mappings
}

export function mapAlxToAggregate(
  rows: AlxPassRow[],
  passMappings: Record<string, string> = {}
): AggregateResult {
  const out: AggregateRow[] = []
  for (const row of rows) {
    const mapped = (passMappings[row.passName] ?? '').trim() || row.passName
    out.push(rowToAggregate(row, mapped))
  }
  return { rows: out }
}
